import { render, staticRenderFns } from "./PatientVitalsCard.vue?vue&type=template&id=e60e2648&scoped=true&"
import script from "./PatientVitalsCard.vue?vue&type=script&lang=js&"
export * from "./PatientVitalsCard.vue?vue&type=script&lang=js&"
import style0 from "./PatientVitalsCard.vue?vue&type=style&index=0&id=e60e2648&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60e2648",
  null
  
)

export default component.exports